export default __webpack_public_path__ + "static/8-hologram-69de70f6bedb8d74d2206c248f656fe3.png";